import React from 'react';

const samples = [
  'https://images.unsplash.com/photo-1609840112855-9e37f4f7e2b5?w=1200&q=80',
  'https://images.unsplash.com/photo-1588776814546-daab30f310ce?w=1200&q=80',
  'https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=1200&q=80',
  'https://images.unsplash.com/photo-1598257006463-a3088fd4f03b?w=1200&q=80',
  'https://images.unsplash.com/photo-1588774069168-4f4f7a73f2b9?w=1200&q=80',
  'https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=1200&q=80'
];

const Gallery = () => (
  <div className="pt-28 pb-16 container-custom px-4 space-y-8">
    <div className="glass-card p-8">
      <h1 className="text-3xl md:text-4xl font-bold text-[#0f172a] mb-3">Galeri</h1>
      <p className="text-[#475569] text-lg">Klinigimizden, ekipten ve ornek gulus donusumlerinden secili gorseller.</p>
    </div>

    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {samples.map((src, i) => (
        <div key={src} className="glass-card p-2">
          <img src={src} alt={`gallery-${i + 1}`} className="w-full h-56 object-cover rounded-xl" />
        </div>
      ))}
    </div>
  </div>
);

export default Gallery;
